import { getTotalItems } from "../dtrUtils";
import styles from "../Dtr.module.css";

/** The cut-off in numbers: one tinted panel, label / value pairs with dividers. */
export const CutoffSummary = ({ totals, title }) =>
  !totals ? null : (
    <div className={styles.cutoffSummary}>
      <div className={styles.cutoffSummaryTitle}>
        {title || "Cut-off total"}
      </div>
      <dl className={styles.cutoffSummaryList}>
        {getTotalItems(totals).map((item) => (
          <div key={item.label} className={styles.cutoffSummaryItem}>
            <dt>
              <i className={`bi ${item.icon} me-1`} aria-hidden="true"></i>
              {item.label}
            </dt>
            <dd>{item.value ?? 0}</dd>
          </div>
        ))}
      </dl>
    </div>
  );

// compact: one strip of small stats (4×2 on phones), for weeks and the cut-off summary
const DtrTotals = ({ totals, compact }) => {
  if (!totals) return null;

  return (
    <div className={compact ? styles.totalsStrip : styles.totalsGrid}>
      {getTotalItems(totals).map((item) => (
        <div key={item.label} className={styles.totalCard}>
          <div className={styles.totalLabel}>{item.label}</div>
          <div className={styles.totalValue}>{item.value ?? 0}</div>
        </div>
      ))}
    </div>
  );
};

export default DtrTotals;
